import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Bienvenue");
      navigate("/profiles");
    } else {
      setErr(res.error);
    }
  };

  return (
    <div className="min-h-screen pt-28 flex items-start justify-center px-6">
      <div className="w-full max-w-md space-y-8 bg-[color:var(--ns-card)] border border-white/10 rounded-2xl p-8">
        <div className="space-y-2 text-center">
          <div className="font-mono-mini text-[11px] uppercase tracking-[0.4em] text-[color:var(--ns-accent)]">
            Accès membres
          </div>
          <h1 className="font-display text-4xl uppercase">Connexion</h1>
          <p className="text-sm text-zinc-400">Reprenez votre session de visionnage</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <label className="font-mono-mini text-[11px] uppercase tracking-widest text-zinc-400">
              Email
            </label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 bg-black/40 border border-white/10 rounded-lg outline-none focus:border-[color:var(--ns-accent)] transition"
            />
          </div>
          <div className="space-y-1.5">
            <label className="font-mono-mini text-[11px] uppercase tracking-widest text-zinc-400">
              Mot de passe
            </label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-3 bg-black/40 border border-white/10 rounded-lg outline-none focus:border-[color:var(--ns-accent)] transition"
            />
          </div>
          {err && (
            <div data-testid="login-error" className="text-sm text-[color:var(--ns-accent)] bg-[color:var(--ns-accent)]/10 border border-[color:var(--ns-accent)]/30 rounded px-3 py-2">
              {err}
            </div>
          )}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full py-3 btn-accent rounded-lg font-semibold uppercase tracking-widest text-sm disabled:opacity-60"
          >
            {loading ? "Connexion…" : "Entrer"}
          </button>
        </form>
        <div className="text-center text-sm text-zinc-400">
          Pas encore de compte ?{" "}
          <Link to="/register" className="text-white underline hover:text-[color:var(--ns-accent)]">
            Créer un compte
          </Link>
        </div>
      </div>
    </div>
  );
}
